//@ts-nocheck
import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib/axios';
import { isPlaceSearchError } from 'components/PlaceAutocomplete/PlaceSearchUnavailableNotice';

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  scope: 'all',
  competenceAreas: [],
  place: null,
  radiusKm: 25,
  ownerTypes: [],
  buyerID: null,
  sortBy: 'dateCreated',
  queryKey: ['jobAds'],
  queryOptions: {},
};

const getAll = async (queryStringParams) => {
  // return [];
  const queryString = qs.stringify({ ...queryStringParams }, {
    arrayFormat: 'repeat',
    skipNulls: true,
  });

  try {
    const { data } = await axios.get(`/website/job_ads?${queryString}`);

    return data;
  } catch (error) {
    if (isPlaceSearchError(error)) {
      throw error;
    }
    console.log(error);
  }

  return { data: [], total: 0};  
};

export const useGetAll = (queryParams = {}) => {
  const { queryKey, queryOptions, page, limit,  search, competenceAreas, place, radiusKm, ownerTypes, buyerID } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    search,
    competence_area_ids: competenceAreas,
    place_id: place?.place_id ?? null,
    radius_km: place ? radiusKm : null,
    owner_types: ownerTypes,
    buyer_id: buyerID,
    offset: page * limit,
  };

  return useQuery([...queryKey, place?.place_id, radiusKm, ...competenceAreas, ...ownerTypes, buyerID], () => getAll(queryStringParams), {
    select: ({ data: jobAds, total, search_area }) => ({ jobAds: jobAds ?? [], total, searchArea: search_area ?? null }),
    initialData: {
      jobAds: [],
      total: 0,
    },
    retry: (failureCount, error) => !isPlaceSearchError(error) && failureCount < 3,
    ...queryOptions,
  });
};
